import { getMargin } from '$lib/data/userInteract';
import { userBalances } from '$lib/home/store';
import { refreshUserHoldings } from '$lib/home/userHoldings/userHoldings';
import {
	accessibleMarginAdjustPopup,
	adjustMarginMarket,
	depositInProgress,
	marginInput,
	withdrawInProgress
} from '$lib/home/userInteract/store';
import { refreshUserInteract, updateData } from '$lib/home/userInteract/userInteract';
import {
	addErrorNotification,
	addTransactionNotification
} from '$lib/notifications/notificationManager';

import type { SendTransactionResult } from '@wagmi/core';
import { get } from 'svelte/store';
import { popupModalOpen } from '../popupsStore';
import { ethers } from 'ethers';
import { getParsedError } from '$lib/web3/errorHandling';
import { addMarginSmartContract, removeMarginSmartContract } from '$lib/web3/actions/margin';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import { getStablesPrices } from '$lib/data/matchaCallData';

export async function executeDeposit(_marginInput: string, _userBalance: string) {
	try {
		depositInProgress.set(true);
		let tx: SendTransactionResult;

		if (_marginInput === _userBalance) {
			tx = await addMarginSmartContract(
				ethers.constants.MaxUint256.toString(),
				get(adjustMarginMarket),
				get(smartContractWalletAddress) as `0x${string}`
			);
		} else {
			tx = await addMarginSmartContract(
				get(marginInput),
				get(adjustMarginMarket),
				get(smartContractWalletAddress) as `0x${string}`
			);
		}
		depositInProgress.set(false);
		popupModalOpen.set(false);
		addTransactionNotification(
			'Margin Deposited',
			'Your transaction has been confirmed',
			tx,
			() => {
				refreshUserInteract();
				refreshUserHoldings();
				getMargin();
				getStablesPrices(get(userBalances));
			}
		);
	} catch (e: any) {
		depositInProgress.set(false);
		popupModalOpen.set(false);
		const { title, description } = getParsedError(e);
		addErrorNotification(title, description, JSON.stringify(e));
	}
}

export async function executeWithdraw(_marginInput: string, _accessibleMarginAdjustPopup: string) {
	try {
		withdrawInProgress.set(true);
		let tx: SendTransactionResult;
		if (_marginInput === _accessibleMarginAdjustPopup) {
			tx = await removeMarginSmartContract(
				ethers.constants.MaxUint256.toString(),
				get(adjustMarginMarket),
				get(smartContractWalletAddress) as `0x${string}`
			);
		} else {
			tx = await removeMarginSmartContract(
				get(marginInput),
				get(adjustMarginMarket),
				get(smartContractWalletAddress) as `0x${string}`
			);
		}
		withdrawInProgress.set(false);
		popupModalOpen.set(false);
		addTransactionNotification(
			'Withdraw processed',
			'Your transaction has been confirmed',
			tx,
			() => {
				refreshUserInteract();
				refreshUserHoldings();
				getMargin();
				getStablesPrices(get(userBalances));
			}
		);
	} catch (e: any) {
		withdrawInProgress.set(false);
		popupModalOpen.set(false);
		const { title, description } = getParsedError(e);
		addErrorNotification(title, description, JSON.stringify(e));
	}
}
